<template>
  <div class="f-countdownPanel">
    <!--<div id="f-backgroundImage"></div>-->
    <ul class="cb-slideshow list-unstyled">
      <li><span> </span></li>
      <li><span> </span></li>
      <li><span> </span></li>
      <li><span> </span></li>
      <li><span> </span></li>
      <li><span> </span></li>
    </ul>

    <b-container class="contentPage" fluid>
      <b-row no-gutters>
        <b-col>
          <countdown-header></countdown-header>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col>
          <countdown-timer date="October 4, 2018 16:00:00"></countdown-timer>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col>
          <countdown-footer></countdown-footer>
          <MainFooter></MainFooter>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
  import CountdownTimer from './CountdownTimer'
  import CountdownHeader from './CountdownHeader'
  import CountdownFooter from './CountdownFooter'
  import MainFooter from '../footerComponents/MainFooter'

  export default {
    name: 'CountdownPanel',
    components: {MainFooter, CountdownFooter, CountdownHeader, CountdownTimer},
    data () {
      return {
        currentBg: 0
      }
    },
    props: {
      default: {
        type: Object
      }
    },
    methods: {
      handleCurrentView () {
        this.$store.commit('setCurrentView', this.default)
      },
      changeBackground () {
        document.getElementById('f-backgroundImage').className = 'image_bg' + this.currentBg
        this.currentBg = (this.currentBg + 1) % 6
      }
    },
    mounted: function () {
      this.handleCurrentView()
      document.getElementsByTagName('head')[0].removeChild(document.getElementById('mobile-meta-tag'))
      let meta = document.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
      meta.id = 'mobile-meta-tag-counter'
      document.getElementsByTagName('head')[0].appendChild(meta)
      // this.changeBackground()
      // let self = this
      // setInterval(function () {
      //   self.changeBackground()
      // }, 5000)
    },
    updated: function () {
      this.handleCurrentView()
    }
  }
</script>

<style scoped>

  .f-countdownPanel {
    height: 100%;
    margin: 0 !important;
  }

  #f-backgroundImage {
    height: 100%;
    -webkit-filter: blur(4px); /* Safari */
    filter: blur(4px);
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
  }

  .contentPage {
    padding: 0;
  }

  .image_bg0 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background1_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  .image_bg1 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background2_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  .image_bg2 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background3_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  .image_bg3 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background4_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  .image_bg4 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background5_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  .image_bg5 {
    background: url('../../assets/alpfoodway_images/alpfoodway_background6_resized.jpg') no-repeat fixed center;
    background-size: cover;
    transition: 1s;
  }

  /*__________________________________________________________*/

  .cb-slideshow,
  .cb-slideshow:after {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 0;
  }

  .cb-slideshow:after {
    content: '';
    background: transparent url('../../assets/alpfoodway_images/pattern.png') repeat top left;
  }

  .cb-slideshow li span {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: none;
    opacity: 0;
    z-index: 0;
    -webkit-backface-visibility: hidden;
    -webkit-animation: imageAnimation 36s linear infinite 0s;
    -moz-animation: imageAnimation 36s linear infinite 0s;
    -o-animation: imageAnimation 36s linear infinite 0s;
    -ms-animation: imageAnimation 36s linear infinite 0s;
    animation: imageAnimation 36s linear infinite 0s;
  }

  .cb-slideshow li div {
    z-index: 1000;
    position: absolute;
    bottom: 30px;
    left: 0px;
    width: 100%;
    text-align: center;
    opacity: 0;
    -webkit-animation: titleAnimation 36s linear infinite 0s;
    -moz-animation: titleAnimation 36s linear infinite 0s;
    -o-animation: titleAnimation 36s linear infinite 0s;
    -ms-animation: titleAnimation 36s linear infinite 0s;
    animation: titleAnimation 36s linear infinite 0s;
  }

  .cb-slideshow li:nth-child(1) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background1_resized.jpg')
  }

  .cb-slideshow li:nth-child(2) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background2_resized.jpg');
    -webkit-animation-delay: 6s;
    -moz-animation-delay: 6s;
    -o-animation-delay: 6s;
    -ms-animation-delay: 6s;
    animation-delay: 6s;
  }

  .cb-slideshow li:nth-child(3) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background3_resized.jpg');
    -webkit-animation-delay: 12s;
    -moz-animation-delay: 12s;
    -o-animation-delay: 12s;
    -ms-animation-delay: 12s;
    animation-delay: 12s;
  }

  .cb-slideshow li:nth-child(4) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background4_resized.jpg');
    -webkit-animation-delay: 18s;
    -moz-animation-delay: 18s;
    -o-animation-delay: 18s;
    -ms-animation-delay: 18s;
    animation-delay: 18s;
  }

  .cb-slideshow li:nth-child(5) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background5_resized.jpg');
    -webkit-animation-delay: 24s;
    -moz-animation-delay: 24s;
    -o-animation-delay: 24s;
    -ms-animation-delay: 24s;
    animation-delay: 24s;
  }

  .cb-slideshow li:nth-child(6) span {
    background-image: url('../../assets/alpfoodway_images/alpfoodway_background6_resized.jpg');
    -webkit-animation-delay: 30s;
    -moz-animation-delay: 30s;
    -o-animation-delay: 30s;
    -ms-animation-delay: 30s;
    animation-delay: 30s;
  }

  .cb-slideshow li:nth-child(2) div {
    -webkit-animation-delay: 6s;
    -moz-animation-delay: 6s;
    -o-animation-delay: 6s;
    -ms-animation-delay: 6s;
    animation-delay: 6s;
  }

  .cb-slideshow li:nth-child(3) div {
    -webkit-animation-delay: 12s;
    -moz-animation-delay: 12s;
    -o-animation-delay: 12s;
    -ms-animation-delay: 12s;
    animation-delay: 12s;
  }

  .cb-slideshow li:nth-child(4) div {
    -webkit-animation-delay: 18s;
    -moz-animation-delay: 18s;
    -o-animation-delay: 18s;
    -ms-animation-delay: 18s;
    animation-delay: 18s;
  }

  .cb-slideshow li:nth-child(5) div {
    -webkit-animation-delay: 24s;
    -moz-animation-delay: 24s;
    -o-animation-delay: 24s;
    -ms-animation-delay: 24s;
    animation-delay: 24s;
  }

  .cb-slideshow li:nth-child(6) div {
    -webkit-animation-delay: 30s;
    -moz-animation-delay: 30s;
    -o-animation-delay: 30s;
    -ms-animation-delay: 30s;
    animation-delay: 30s;
  }

  @-webkit-keyframes imageAnimation {
    0% {
      opacity: 0;
      -webkit-animation-timing-function: ease-in;
    }
    8% {
      opacity: 1;
      -webkit-transform: scale(1.05);
      -webkit-animation-timing-function: ease-out;
    }
    17% {
      opacity: 1;
      -webkit-transform: scale(1.1);
    }
    22% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-20%);
    }
    25% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-100%);
    }
    100% {
      opacity: 0
    }
  }

  @-moz-keyframes imageAnimation {
    0% {
      opacity: 0;
      -moz-animation-timing-function: ease-in;
    }
    8% {
      opacity: 1;
      -moz-transform: scale(1.05);
      -moz-animation-timing-function: ease-out;
    }
    17% {
      opacity: 1;
      -moz-transform: scale(1.1);
    }
    22% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-20%);
    }
    25% {
      opacity: 0;
      -moz-transform: scale(1.1) translateY(-100%);
    }
    100% {
      opacity: 0
    }
  }

  @-o-keyframes imageAnimation {
    0% {
      opacity: 0;
      -o-animation-timing-function: ease-in;
    }
    8% {
      opacity: 1;
      -o-transform: scale(1.05);
      -o-animation-timing-function: ease-out;
    }
    17% {
      opacity: 1;
      -o-transform: scale(1.1);
    }
    22% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-20%);
    }
    25% {
      opacity: 0;
      -o-transform: scale(1.1) translateY(-100%);
    }
    100% {
      opacity: 0
    }
  }

  @-ms-keyframes imageAnimation {
    0% {
      opacity: 0;
      -ms-animation-timing-function: ease-in;
    }
    8% {
      opacity: 1;
      -ms-transform: scale(1.05);
      -ms-animation-timing-function: ease-out;
    }
    17% {
      opacity: 1;
      -ms-transform: scale(1.1);
    }
    22% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-20%);
    }
    25% {
      opacity: 0;
      -ms-transform: scale(1.1) translateY(-100%);
    }
    100% {
      opacity: 0
    }
  }

  @keyframes imageAnimation {
    0% {
      opacity: 0;
      animation-timing-function: ease-in;
    }
    8% {
      opacity: 1;
      transform: scale(1.05);
      animation-timing-function: ease-out;
    }
    17% {
      opacity: 1;
      transform: scale(1.1);
    }
    22% {
      opacity: 0;
      -webkit-transform: scale(1.1) translateY(-20%);
    }
    25% {
      opacity: 0;
      -transform: scale(1.1) translateY(-100%);
    }
    100% {
      opacity: 0
    }
  }

  @-webkit-keyframes titleAnimation {
    0% {
      opacity: 0;
      -webkit-transform: translateY(-300%);
    }
    8% {
      opacity: 1;
      -webkit-transform: translateY(0%);
    }
    17% {
      opacity: 1;
      -webkit-transform: translateY(0%);
    }
    19% {
      opacity: 0;
      -webkit-transform: translateY(100%);
    }
    25% {
      opacity: 0
    }
    100% {
      opacity: 0
    }
  }

  @-moz-keyframes titleAnimation {
    0% {
      opacity: 0;
      -moz-transform: translateY(-300%);
    }
    8% {
      opacity: 1;
      -moz-transform: translateY(0%);
    }
    17% {
      opacity: 1;
      -moz-transform: translateY(0%);
    }
    19% {
      opacity: 0;
      -moz-transform: translateY(100%);
    }
    25% {
      opacity: 0
    }
    100% {
      opacity: 0
    }
  }

  @-o-keyframes titleAnimation {
    0% {
      opacity: 0;
      -o-transform: translateY(-300%);
    }
    8% {
      opacity: 1;
      -o-transform: translateY(0%);
    }
    17% {
      opacity: 1;
      -o-transform: translateY(0%);
    }
    19% {
      opacity: 0;
      -o-transform: translateY(100%);
    }
    25% {
      opacity: 0
    }
    100% {
      opacity: 0
    }
  }

  @-ms-keyframes titleAnimation {
    0% {
      opacity: 0;
      -ms-transform: translateY(-300%);
    }
    8% {
      opacity: 1;
      -ms-transform: translateY(0%);
    }
    17% {
      opacity: 1;
      -ms-transform: translateY(0%);
    }
    19% {
      opacity: 0;
      -ms-transform: translateY(100%);
    }
    25% {
      opacity: 0
    }
    100% {
      opacity: 0
    }
  }

  @keyframes titleAnimation {
    0% {
      opacity: 0;
      transform: translateY(-300%);
    }
    8% {
      opacity: 1;
      transform: translateY(0%);
    }
    17% {
      opacity: 1;
      transform: translateY(0%);
    }
    19% {
      opacity: 0;
      transform: translateY(100%);
    }
    25% {
      opacity: 0
    }
    100% {
      opacity: 0
    }
  }

  /* Show at least something when animations not supported */
  .no-cssanimations .cb-slideshow li span {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/countdownComponents/CountdownPanel.vue